import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';

var Row = function Row(_a) {
  var children = _a.children,
      restProps = __rest(_a, ["children"]);

  var gutters = restProps.gutters,
      className = restProps.className,
      style = restProps.style,
      otherProps = __rest(restProps, ["gutters", "className", "style"]);

  return /*#__PURE__*/React.createElement("div", _Object$assign({}, otherProps, {
    className: classNames('row', className, {
      'no-gutters': !gutters
    }),
    style: style
  }), children);
};

Row.defaultProps = {
  className: undefined,
  gutters: true
};
Row.propTypes = {
  className: PropTypes.string,
  gutters: PropTypes.bool
};
export default Row;